<template>
<div style="height:100%;overflow-y:auto">
<v-toolbar dark class="primary">
    <v-btn @click.native="$router.push('/home')" icon>
        <v-icon>chevron_left</v-icon>
    </v-btn>
    <v-toolbar-title>Preferences</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-progress-circular v-if="loadingMessage" indeterminate class="white--text"></v-progress-circular>
    <v-menu offset-y>
        <template v-slot:activator="{ on }">
            <v-icon v-on="on">more_vert</v-icon>
        </template>
        <v-list>
            <v-list-item @click="debugMyRecord">
                <v-list-item-title>Debug my Record</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>

</v-toolbar>

<div class="pa-5 grey--text">
    <v-btn @click="$router.push('/templates')" class="primary">Templates</v-btn>
    <!-- <v-btn @click="contactSelector.visible = true" class="primary">Master Contact</v-btn> -->
    <v-btn @click="sendTestEmail" class="primary">Test Email</v-btn>
</div>

<v-tabs color="blue" v-model="tab">
    <v-tab :key="0" ripple>
        Email
    </v-tab>
    <v-tab :key="1" ripple>
        SMS
    </v-tab>
    <v-tab :key="2" ripple>
        Billing
    </v-tab>
    <!-- <v-tab :key="3" ripple>
        Team Settings
    </v-tab>            -->

    <!-- <v-container> -->
        <v-tab-item :key="0">
            <v-card-text>
                <v-row wrap>
                    <v-col>
                        Email Signature<br/><br/>
                        <div style="padding:0px;height:200px">
                            <HtmlEditor v-model="email.signature" :height="180" />
                        </div>
                        <br/><br/>
                        <v-text-field v-model="email.cc" label="Automatic CC"></v-text-field>
                        <v-text-field v-model="email.bcc" label="Automatic BCC"></v-text-field>
                        <v-text-field v-model="email.billing" label="Email for Billing"></v-text-field>
                        <div class="element-label">Outbound email can come from the brokers email address</div>
                        <v-switch v-model="email.broker" label="Send from Broker" class="compact" xhide-details />

                        <v-switch v-model="email.copyMe" label="Copy me Privately" class="compact" hide-details />
                        <div class="element-label">Everything will be copied to you. Email will be tagged with 'TACO-SENT' so you can autofilter</div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-tab-item>

        <v-tab-item :key="1">
            <v-card-text>
                <v-row wrap>
                    <v-col>
                        <v-text-field v-model="sms.prefix" label="Prefix SMS With"></v-text-field>
                        <v-text-field v-model="sms.suffix" label="Suffix SMS With"></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-tab-item>

        <v-tab-item  :key="2">
            <v-card-text>
                <v-text-field v-model="billing.email" label="Email for Billing (if different to yours)"></v-text-field>
                <v-text-field v-model="billing.directDebitRef" label="Direct Debit Ref"></v-text-field>
                <v-textarea v-model="billing.entity" label="Billing Entity and Address"></v-textarea>
            </v-card-text>
        </v-tab-item>

        <!-- <v-tab-item  :key="3">
            <v-card-text>
                <v-switch v-model="teamSettings.blankAvatars" label="Blank avatars for new contacts"  color="primary"></v-switch>
            </v-card-text>
        </v-tab-item>          -->
    <!-- </v-container> -->
</v-tabs>

  <v-container>
    <v-row wrap>
        <v-col>
            <v-btn @click.native="save">Save</v-btn>
            <v-btn @click="$router.go(-1)">Cancel</v-btn>
        </v-col>
    </v-row>
  </v-container>

  <!-- <ContactSelector :visible="contactSelector.visible" title="Master Contact" :data="contactSelector.data" @select="selectTemplateContact" @cancel="contactSelector.visible = false"></ContactSelector> -->


</div>
</template>

<script>

    import firebase from 'firebase/app'
    import 'firebase/database'
    import FirebaseHelpers from '../helpers/FirebaseHelpers'
    import EmailHelpers from '../helpers/EmailHelpers'
    import StringHelpers from '../helpers/StringHelpers'
    import DataHelpers from '../helpers/DataHelpers'
    import yesNo from '../ui-elements/YesNo'
    import HtmlEditor from '../ui-elements/HtmlEditor'



    import ContactSelector from '../ui-elements/ContactSelector'
import TeamHelpers from '../helpers/TeamHelpers'


    var db = firebase.database()

    export default {
        name: 'Preferences',
        components: {
            'ContactSelector': ContactSelector,
            'YesNo': yesNo,
            HtmlEditor,

        },
        props: {
            tenantKey: String,
            uid: String,
        },
        data() {
            return {
                teamSettings: {

                },
                ans1: null,
                ans2: null,
                email: {
                    signature: null,
                    cc: null,
                    bcc: null,
                    billing: null,
                },
                tab: 0,
                sms: {
                    prefix: null,
                    suffix: null,
                },
                billing: {
                    email: null,
                    entity: null,
                    directDebitRef: null
                },

                // Navigation Drawer
                drawer: null,
                mini: true,

                // Contact Selector
                contactSelector: {
                    visible: false,
                    data: {}
                }

            }
        },
        computed:{

            preferencesRef() {
                if(this.tenantKey && this.uid)
                    return DataHelpers.getRootRef().child('users').child(this.uid).child('offices').child(this.tenantKey).child('preferences')
                else
                    return DataHelpers.getPreferencesRef()
            },

            loadingMessage () {
                return this.$store.getters.loadingMessage
            }

        },
        watch: {

        },
        methods: {

            debugMyRecord() {
                let uid = this.uid
                FirebaseHelpers.viewInConsole('users/' + uid)

            },

            sendTestEmail() {
                EmailHelpers.sendTest()
                console.log('sent')
            },

            selectTemplateContact() {
                console.log ('preferences > selectTemplateContact')

            },

            // masterTransaction() {
            //     let templateTransactionKey = DataHelpers.templateTransactionKey()
            //     this.$router.push('/transactions/' + templateTransactionKey)
            // },

            // updateSignature (html) {
            //     console.log ('updating signature')
            //     this.email.signature = html
            // },

            save () {

                console.log('Preferences ref is ', this.preferencesRef)
                this.preferencesRef.child('email').update(this.email)
                this.preferencesRef.child('sms').update(this.sms)
                this.preferencesRef.child('billing').update(this.billing)
                TeamHelpers.saveTeamSettings(this.teamSettings)
                this.$router.push('/home')
            },

            async load() {


                let vm = this

                this.preferencesRef.child('email').once('value', function(snap) {
                    if(snap.val()) {
                        vm.email.signature = snap.val().signature || null
                        vm.email.cc = snap.val().cc || null
                        vm.email.bcc = snap.val().bcc || null
                        vm.email.billing = snap.val().billing || null
                        vm.email.broker = snap.val().broker || null
                        vm.email.copyMe = snap.val().copyMe || null
                    }
                })
                this.preferencesRef.child('sms').once('value', function(snap) {
                    if(snap.val()) {
                        vm.sms.prefix = snap.val().prefix || null
                        vm.sms.suffix = snap.val().suffix || null
                    }
                })
                this.preferencesRef.child('billing').once('value', function(snap) {
                    if(snap.val()) {
                        vm.billing.email = snap.val().email || null
                        vm.billing.entity = snap.val().entity || null
                        vm.billing.directDebitRef = snap.val().directDebitRef || null
                    }
                })

                this.teamSettings = await TeamHelpers.fetchTeamSettings()
            }

        },
        created () {
            DataHelpers.fetchUser().then(() => {
                this.load()
            })

        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// Preferences.vue?1a390164